export enum Drinks {
  beer = "beer",
  wine = "wine",
  pint = "pint",
  spirit = "spirit"
}

export type DrinksIndexer<T> = {
  [id in Drinks]: T;
};

interface DrinkDescription {
  description: string;
  title: string;
}

export type DrinksDescription = DrinksIndexer<DrinkDescription>;
